import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Alert, Snackbar } from "@mui/material";
import Loader from "../../Loader/Loader";
import { approvdeliver, deliverrequestlist } from "../../service/Mainservice";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

const DrequestList = () => {
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setmsg] = useState("");
  const [imageError, setImageError] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    setImageError(false); // Reset when image changes
  }, [currentIndex]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setloading(true);
      const response = await deliverrequestlist();
      setData(response?.data?.data || []);
      setloading(false);
    } catch (error) {
      setloading(false);
      if (error?.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handleaccept = async (id) => {
    try {
      setloading(true);
      const params = {
        id: id,
        approvalStatus: "Accept",
      };
      const response = await approvdeliver(params);
      setOpen(true);
      setmsg(response?.data?.message || "Accepted");
      getData();
    } catch (error) {
      setloading(false);
    }
  };

  const handlereject = async (id) => {
    try {
      setloading(true);
      const params = {
        id: id,
        approvalStatus: "Reject",
      };
      const response = await approvdeliver(params);
      setOpen(true);
      setmsg(response?.data?.message || "Rejected");
      getData();
    } catch (error) {
      setloading(false);
    }
  };

  // ✅ Open preview modal
  const handlePreview = (images, index) => {
    const urls = images.map((img) => img?.data?.[0]);
    setPreviewImages(urls);
    setCurrentIndex(index);
    setPreviewOpen(true);
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Driver Applications</h1>
        </div>

        {data.length > 0 ? (
          <div className="data_table_over">
            <table className="data_table">
              <thead>
                <tr>
                  <th>Driver</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Documents</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {data.map((item) => (
                  <tr key={item.id}>
                    {/* Driver */}
                    <td className="user_name">
                      {item?.documents?.images?.length > 0 ? (
                        <img
                          src={item.documents.images[0]?.data?.[0]}
                          className="data_userdetails_img"
                        />
                      ) : item?.image ? (
                        <img
                          src={item.image}
                          className="data_userdetails_img"
                        />
                      ) : (
                        <div className="data_userdetails_img">
                          <PersonOutlineIcon />
                        </div>
                      )}
                      {item.fullName}
                    </td>

                    <td>{item.mobileNumber}</td>
                    <td>{item.email}</td>

                    {/* ✅ Documents with click preview */}
                    <td>
                      <div style={{ display: "flex", gap: 5 }}>
                        {item?.documents?.images?.length > 0 ? (
                          item.documents.images.map((img, i) => (
                            <img
                              key={i}
                              src={img?.data?.[0]}
                              style={{
                                width: 40,
                                height: 40,
                                borderRadius: 5,
                                cursor: "pointer",
                                objectFit: "cover",
                              }}
                              onClick={() =>
                                handlePreview(item.documents.images, i)
                              }
                            />
                          ))
                        ) : (
                          <span style={{ color: "#999" }}>No docs</span>
                        )}
                      </div>
                    </td>

                    {/* Actions */}
                    <td>
                      <div className="action_button">
                        <button
                          className="active_user"
                          onClick={() => handleaccept(item.id)}
                        >
                          Accept
                        </button>

                        <button
                          className="block_user"
                          onClick={() => handlereject(item.id)}
                        >
                          Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          !loading && <p className="nodata">No Driver requests available</p>
        )}

        {/* Snackbar */}
        <Snackbar
          open={open}
          autoHideDuration={4000}
          onClose={() => setOpen(false)}
        >
          <Alert variant="filled" severity="success">
            {msg}
          </Alert>
        </Snackbar>
      </div>

      {/* ✅ Preview Modal */}
      {previewOpen && (
        <div className="preview_modal">
          <div
            className="preview_overlay"
            onClick={() => setPreviewOpen(false)}
          />

          <div className="preview_content">
            <button className="close_btn" onClick={() => setPreviewOpen(false)}>
              ✕
            </button>

            {imageError ? (
              <div className="image_error">Image not available</div>
            ) : (
              <img
                src={previewImages[currentIndex]}
                alt="preview"
                className="preview_image"
                onError={() => setImageError(true)}
              />
            )}

            <div className="preview_nav">
              <button
                disabled={currentIndex === 0}
                onClick={() => setCurrentIndex((prev) => prev - 1)}
              >
                ◀
              </button>

              <button
                disabled={currentIndex === previewImages.length - 1}
                onClick={() => setCurrentIndex((prev) => prev + 1)}
              >
                ▶
              </button>
            </div>
          </div>
        </div>
      )}

      {loading && <Loader />}
    </>
  );
};

export default DrequestList;
